import { BASE_URL, PLANS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IPlan, IPlanInput } from "models/plan";

export async function getPlans(params: string = "") : Promise<IPlan[]> {
  const response = await axios.get(BASE_URL + PLANS + params);
  return response.data;
}
export async function addPlan(data: IPlanInput) {
  const response = await axios.post(BASE_URL + PLANS, data);
  return response.data;
}
export async function editPlan(data: IPlanInput, id: string) {
  const response = await axios.patch(BASE_URL + PLANS + "/" + id , data);
  return response.data;
}

export async function deletePlan(id: string) {
  const response = await axios.delete(BASE_URL + PLANS + "/" + id);
  return response.data;
}

export const PlanCells: HeadCell[] = [
  {
    id: "planName",
    numeric: false,
    disablePadding: false,
    label: "Plan Name",
  },
  {
    id: "period",
    numeric: true,
    disablePadding: false,
    label: "Period (In Months)",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];
